import { apiClient } from '@/api/client';
import type { CurrentUser } from '@/api/types';

export interface LoginPayload {
  /** Acepta el nombre de usuario o el correo. */
  username: string;
  password: string;
}

export interface LoginResponse {
  access: string;
  user: CurrentUser;
}

export const authApi = {
  /** Returns the access token in the body; the refresh token arrives as an HttpOnly cookie. */
  async login(payload: LoginPayload): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/api/v1/auth/login/', payload);
    return data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/api/v1/auth/logout/');
  },

  /** Cambia la contraseña y baja `must_change_password`. */
  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await apiClient.post('/api/v1/auth/change-password/', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },

  /**
   * Who am I, what may I do, and what can I reach.
   *
   * Also serves as the session-restore call: on a page refresh the in-memory
   * access token is gone, so the app asks here and the refresh cookie either
   * produces a new token or it does not.
   */
  async me(): Promise<CurrentUser> {
    const { data } = await apiClient.get<CurrentUser>('/api/v1/auth/me/');
    return data;
  },
};
